<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <b-row class="justify-content-center align-items-center">
      <b-col cols="12" md="10">
          <div class="mt-3 text-right">
            <img
              v-if="loading"
              class="loading"
              src="@/assets/images/loader.gif"
              alt
            />
          </div>
          <br>
        <div class="mx-auto" v-if="!loading">
          <div class="text-justify">
            <h4 class="color-secundary mb-4" v-text="'Numeros de cesión'"></h4>
          </div>
          <hr>
          <div class="text-justify">
            <div v-text="'Recuerde colocar los numeros de cesión separados por coma y sin espacios en blanco'" style="padding: 0px 0px 15px 0px;"></div>
          </div>
          <form @submit.prevent="validarCesion()">
            <div class="form-group row">
              <div class="col-lg-6 col-md-12">
                <div class="input-group mb-3">
                  <select class="form-control" id="datos_convenios" :disabled="loading || datos_cesion.length > 0" v-model="archivo_cesion" required>
                    <option :value="null" disabled>Seleccione un archivo</option>
                    <option v-for="pagos in dataCesion" :key="pagos.archivo" :value="pagos.archivo">
                      {{ pagos.archivo }}
                    </option>
                  </select>
                </div>
                <div class="input-group-append">
                  <b-button type="submit" :disabled="loading || datos_cesion.length > 0" class="ml-1 button-carga">Validar</b-button>
                  <b-button :disabled="loading || datos_cesion.length == 0" class="ml-1 button-carga" @click="restablerCesion()">Restablecer</b-button>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="input-group mb-3">
                <input required type="text" class="form-control" id="numeroCesion" placeholder="Numero de cesión" :disabled="loading || datos_cesion.length > 0" v-model="numero_cesion">
                </div>
                <span style="font-size: 17px;" v-if="fallos_cesion != '' ? fallos_cesion : ''" :class="['text-danger']">Los siguientes codigos no fueron aceptados: {{ fallos_cesion }}</span>
              </div>
            </div>
          </form>
        </div>
        <div class="mx-auto" v-if="dataLengthCesion > 0 && !loading && datos_cesion.length > 0">
          <div class="text-justify">
            <div v-text="'Se asginaran los siguientes numeros de cesión:'" style="padding: 0px 0px 15px 0px;"></div>
          </div>
          <b-list-group horizontal="md" class="custom-list-group">
            <b-list-group-item v-for="dato in datos_cesion" :key="dato.archivo" class="custom-list-item">
              <b-list-group-item>
              <strong>Archivo: </strong>{{ dato.archivo }}
              </b-list-group-item>
              <b-list-group-item>
              <strong>Numero(s) de cesión: </strong>{{ dato.numero_cesion.join(", ") }}
              </b-list-group-item>
            </b-list-group-item>
          </b-list-group>
          <br><b-button :disabled="loading || datos_cesion.length == 0" @click="enviarCesion()" class="ml-1 button-carga">Enviar</b-button></br>
        </div>
        <div class="mx-auto" v-if="!loading">
          <table-component
            :data="dataCesion"
            pagination
            @click-event="clickEvent"
            :perPage="perPage"
            :dataLength="dataLengthCesion"
          >
            <table-column
              slot="label"
              :label="'Nit'"
              v-bind:value="'nit'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Convenio'"
              v-bind:value="'convenio'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Producto'"
              v-bind:value="'producto'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Archivo'"
              v-bind:value="'archivo'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Fecha cargue'"
              v-bind:value="'fecha_cargue'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Total registros'"
              v-bind:value="'total_registros'"
              :customClass="'text-center'"
            ></table-column>
          </table-component>
        </div>
      </b-col>
      <!-- Panel Derecho -->
    </b-row>
  </div>
</template>
<script>
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "NumeroCesion",
  data: () => {
    return {
      pagination:false,
      recomendacion: "En este espacio podrás cargar la documentación requerida para la reclamación",
      perPage: 3,
      dataCesion: [],
      dataLengthCesion: 0,
      end_consulta_cesion: false,
      archivo_cesion: null,
      numero_cesion: null,
      datos_cesion: [],
      fallos_cesion: "",
      envio_cesion: false,
    };
  },
  computed: {
    loading(){
      return this.end_consulta_cesion == true && this.envio_cesion == false ? false : true;
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    async clickEvent(element, slug) {
      console.log(element, slug);
      if ((slug = "paginacion")) {
        this.getPendientes(element.page);
      }
    },
    async getPendientesCesion(page, paginar = "false") {
      this.end_consulta_cesion = false;
      try {
        let request = await this.$store.state.api.get("/informes/cargues_cesion", {
          params: {
            paginar,
            row: this.perPage,
            page,
          },
        });

        this.dataCesion = request.data.datos;
        this.dataLengthCesion = request.data.paginacion.total;
        this.end_consulta_cesion = true;
      } catch (err) {
        this.end_consulta_cesion = true;
        console.log(err);
        this.$toasted.show(
          "Ocurrió un error intentando consultar los registros pendientes para numero certificación",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
    },
    validarCesion(){
      this.fallos_cesion = "";
      const pattern = /^[a-zA-Z0-9]+$/;
      if(this.archivo_cesion && this.archivo_cesion != "", this.numero_cesion && this.numero_cesion != ""){
        let numeros_cesion = this.numero_cesion.split(",");
        let validacion = true;
        let fallos = "";
        numeros_cesion.forEach(numero => {
          if(!pattern.test(numero)){
            validacion = false;
            fallos = fallos + numero;
          }
        });

        if(validacion){
          this.datos_cesion.push({"archivo": this.archivo_cesion, "numero_cesion": numeros_cesion});
          this.archivo_cesion = null;
          this.numero_cesion = null;
        }else{
          this.fallos_cesion = fallos;
          this.$toasted.show(
          "A ocurrido un error al actualizar los datos, porfavor comuniquese con",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
        }

      }
    },
    restablerCesion(){
      this.fallos_cesion = "";
      this.datos_cesion = [];
      this.archivo_cesion = null;
      this.numero_cesion = null;
    },
    async enviarCesion(){
      if (confirm("¿Esta seguro de enviar la información?\nUna vez enviada no podra adiciónar ni cambiar ninguno de los codigos")){
        try {
          this.envio_cesion = true;
          let request = await this.$store.state.api.post(
            "pagos/almacenar_cesion",
              { datos: this.datos_cesion }
            );
          this.$toasted.show(request.data.message,{
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000
          });
          this.envio_cesion = false;
          this.restablerCesion();
          this.getPendientesCesion(1);
      } catch (err) {
        this.envio_cesion = false;
        this.$toasted.show(
          "Lo sentimos, ocurrio un error al intentar actualizar la información",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
      } else {
        this.envio_cesion = false;
      }
    },
  },
  mounted() {
    console.log('Cesion');
    this.getPendientesCesion(1);
  },
};
</script>
<style>
.card-body {
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.4s ease;
}

.card-body:hover {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.custom-list-group {
  display: flex;
  width: 600px;
}

.custom-list-item {
  flex: 1;
}
</style>